import * as React from 'react';
import {
    styled,
    createTheme,
    ThemeProvider
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
    mainListItems,
    LogoutListItem
} from '../../listItems';
import AddIcon from '@mui/icons-material/Add';
import AddDialog from './AddUserDialog';
import UserDetailsPage from './userDetailsTable';

function Copyright(props) {
    return ( <
        Typography variant = "body2"
        color = "text.secondary"
        align = "center" { ...props
        } > {
            'Copyright © '
        } <
        Link color = "inherit"
        href = "https://mui.com/" >
        Crown Bingo <
        /Link>{' '} {
            new Date().getFullYear()
        } {
            '.'
        } <
        /Typography>
    );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({
    theme,
    open
}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open'
})(
    ({
        theme,
        open
    }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

const defaultTheme = createTheme();

export default function Dashboard() {
    const [open, setOpen] = React.useState(true);
    const [addDialogOpen, setAddDialogOpen] = React.useState(false);
    const [addDialogAction, setAddDialogAction] = React.useState('');

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleAddCashier = () => {
        setAddDialogAction('cashier');
        setAddDialogOpen(true);
    };

    const handleAddSuperAdmin = () => {
        setAddDialogAction('super admin');
        setAddDialogOpen(true);
    };

    const handleAddDialogClose = () => {
        setAddDialogOpen(false);
    };

    return ( <
        ThemeProvider theme = {
            defaultTheme
        } >
        <
        Box sx = {
            {
                display: 'flex'
            }
        } >
        <
        CssBaseline / >
        <
        AppBar position = "absolute"
        open = {
            open
        }
        sx = {
            {
                backgroundColor: 'black'
            }
        } >
        <
        Toolbar sx = {
            {
                pr: '24px', // keep right padding when drawer closed
            }
        } >
        <
        IconButton edge = "start"
        color = "inherit"
        aria-label="open drawer"
        onClick = {
            toggleDrawer
        }
        sx = {
            {
                marginRight: '36px',
                ...(open && {
                    display: 'none'
                }),
            }
        } >
        <
        MenuIcon / >
        <
        /IconButton> <
        Typography component = "h1"
        variant = "h6"
        color = "inherit"
        noWrap sx = {
            {
                flexGrow: 1
            }
        } >
        Super Agent Dashboard <
        /Typography> <
        IconButton color = "inherit" >

        <
        /IconButton> <
        /Toolbar> <
        /AppBar> <
        Drawer variant = "permanent"
        open = {
            open
        } >
        <
        Toolbar sx = {
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
            }
        } >
        <
        IconButton onClick = {
            toggleDrawer
        } >
        <
        ChevronLeftIcon / >
        <
        /IconButton> <
        /Toolbar> <
        Divider / >
        <
        List component = "nav" > {
            mainListItems
        } <
        Divider sx = {
            {
                my: 1
            }
        }
        /> <
        LogoutListItem / >
        <
        /List> <
        /Drawer> <
        Box component = "main"
        sx = {
            {
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light' ?
                    theme.palette.grey[100] :
                    theme.palette.grey[900],
                flexGrow: 1,
                height: '100vh',
                overflow: 'auto',
            }
        } >
        <
        Toolbar / >
        <
        Container maxWidth = "lg"
        sx = {
            {
                mt: 4,
                mb: 4
            }
        } >
        <
        Grid container spacing = {
            3
        } >
        <
        Stack width = {
            '100%'
        }
        direction = {
            'row'
        }
        justifyContent = {
            'space-between'
        }
        paddingTop = {
            3
        } >
        <
        Stack direction = {
            'row'
        }
        height = {
            "50%"
        }
        spacing = {
            4
        } > {
            /* <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddSuperAdmin}>
                                Add Super Admin
                              </Button> */
        }

        <
        /Stack> <
        /Stack> <
        Stack width = {
            '100%'
        }
        direction = {
            'row'
        }
        justifyContent = {
            'space-evenly'
        }
        paddingTop = {
            3
        } > {
            /* <Deposits title={'GAME HOUSE BRANCHES'} />
                              <Deposits title={'TOTAL GAMES PLAYED'} />
                              <Deposits title={'TOTAL EARNINGS'} /> */
        } <
        /Stack> <
        Grid item xs = {
            12
        } >
        <
        Paper sx = {
            {
                p: 2,
                display: 'flex',
                flexDirection: 'column'
            }
        } >
        <
        UserDetailsPage / >
        <
        /Paper> <
        /Grid> <
        /Grid> <
        Copyright sx = {
            {
                pt: 4
            }
        }
        /> <
        /Container> <
        /Box> <
        /Box> <
        AddDialog open = {
            addDialogOpen
        }
        handleClose = {
            handleAddDialogClose
        }
        action = {
            addDialogAction
        }
        /> <
        /ThemeProvider>
    );
}